import script from "./ArgonPhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonPhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./ArgonPhoneInput.vue?vue&type=style&index=0&id=4a7deebe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7deebe"]])

export default __exports__